/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useRef, useState } from "react";
import ic_paper_big_circle from "../../assets/images/pictures/icon/ic_paper_big_circle.svg";
import signing_header from "../../assets/images/pictures/signature-collection-header.png";
import ic_radar_circle from "../../assets/images/pictures/icon/ic_radar_circle.svg";
import ic_clock_circle from "../../assets/images/pictures/icon/ic_clock_circle.svg";
import ic_thunder_circle from "../../assets/images/pictures/icon/ic_thunder_big_circle.svg";
import ic_doc from "../../assets/images/pictures/icon/ic_doc.svg";
import ic_clock from "../../assets/images/pictures/icon/ic_clocks.svg";
import ic_download from "../../assets/images/pictures/icon/ic_download.svg";
import ic_sun from "../../assets/images/pictures/icon/ic_sun.svg";
import ic_double_check from "../../assets/images/pictures/icon/ic-double-check-done.svg";
import ic_globe_big_circle from "../../assets/images/pictures/icon/ic_globe_big_circle.svg";
import ic_flag from "../../assets/images/pictures/icon/ic_flag.svg";
import ic_light_bulb from "../../assets/images/pictures/icon/ic-lightbulb-outline-black-24-px.svg";
import ic_key_big_circle from "../../assets/images/pictures/icon/ic_key_big_circle.svg";
import ic_doc_cirlce from "../../assets/images/pictures/icon/ic_doc_circle.svg";
import ic_doc_code_circle from "../../assets/images/pictures/icon/ic_doc-code_circle.svg";
import ic_paper_small_circle from "../../assets/images/pictures/icon/ic_paper_small_circle.svg";
import ic_paper_code_small_circle from "../../assets/images/pictures/icon/ic_paper-code_small_circle.svg";
import document_gateway from "../../assets/images/pictures/document_gateway-en.png";
import gopaperless_intergration from "../../assets/images/pictures/gopaperless-integration.png";
import gopaperless_service from "../../assets/images/pictures/solutions-footer.png";
import ic_download_white from "../../assets/images/pictures/icon/ic_download-white.svg";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "./../../redux/language/selector";
import routeVariants from "../../assets/animates/routeVariants";
import Modal from "../global/Modal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FPT_logo from "../../assets/images/logos/CA/FPT-CA-1.png";

const ESigningApiContent = (props) => {
  const [modalGatewayOpen, setModalGatewayOpen] = useState(false);

  const [modalApiOpen, setModalApiOpen] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (
      modalOpen === true ||
      modalGatewayOpen === true ||
      modalApiOpen === true
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalOpen, modalGatewayOpen, modalApiOpen]);

  const modalRef = useRef(null);

  const handleOverlayClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setModalOpen(false);
      setModalApiOpen(false);
      setModalGatewayOpen(false);
    }
  };

  document.onkeydown = function (evt) {
    if (evt.code === "Escape") {
      setModalOpen(false);
      setModalApiOpen(false);
      setModalGatewayOpen(false);
    }
  };

  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    if (props.following === true) {
      document.getElementById("e-signing-api").classList.add("active", "in");
    } else {
      document.getElementById("e-signing-api").classList.remove("active", "in");
    }
  }, [props.following]);

  function handleOpenTableSigning() {
    document.getElementById("table-signing-open").style.display = "block";
    document.getElementById("see-more-signing").style.display = "none";
  }

  return (
    <>
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        className="tab-pane fade"
        id="e-signing-api"
      >
        <div className="container pt-100 pb-100">
          <div className="row api-solutions">
            <div className="col-sm-6 pl-md-0">
              <img
                width="64"
                height="64"
                src={ic_paper_big_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="heading font-weight-bold">
                {t(
                  "e-signing-api-page.e-signing-api-page-content.content-1.heading"
                )}
              </h2>
              <div className="subheading">
                <p>
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-1.description"
                  )}
                </p>
              </div>
              <ul className="list-inline">
                <li>
                  <img
                    className="client-s-none-width img-bw"
                    src={FPT_logo}
                    alt=""
                  />
                </li>
              </ul>
            </div>
            <div className="col-sm-6 pr-md-0">
              <img
                width="528"
                height="359"
                src={signing_header}
                className="img-responsive"
                alt=""
                decoding="async"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="bg-color">
          <div className="container api-solutions  m-50">
            <div className="row">
              <div className="col-sm-12 px-md-0">
                <div className="rectangle"></div>
                <h2 className="font-weight-bold">
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-2.big-heading"
                  )}
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 mb-30 pl-md-0">
                <img
                  width="40"
                  height="40"
                  src={ic_radar_circle}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-2.small-heading-1"
                  )}
                </h3>
                <p>
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-2.small-description-1"
                  )}
                </p>
              </div>
              <div className="col-sm-6 mb-30 ">
                <img
                  width="40"
                  height="40"
                  src={ic_clock_circle}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-2.small-heading-2"
                  )}
                </h3>
                <p>
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-2.small-description-2"
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-100 api-solutions api-solutions--features">
          <div className="row">
            <div className="text-center col-xs-12">
              <img
                width="64"
                height="64"
                src={ic_thunder_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="font-weight-bold">
                {t(
                  "e-signing-api-page.e-signing-api-page-content.content-3.big-heading"
                )}
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_doc}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-heading-1"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-description-1"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_clock}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-heading-2"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-description-2"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_download}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-heading-3"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-description-3"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_sun}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-heading-4"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-description-4"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="14"
                      src={ic_double_check}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-heading-5"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-3.small-description-5"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="py-100 mt-50 bg-color">
          <div className="container px-md-0">
            <div className="row api-solutions flex v-align">
              <div className="col-sm-6">
                <img
                  width="64"
                  height="64"
                  src={ic_globe_big_circle}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="heading font-weight-bold">
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-4.big-heading"
                  )}
                </h2>
                <p className="subheading">
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-4.big-description"
                  )}
                </p>
                <div className="icon-left-box">
                  <aside>
                    <img
                      width="24"
                      height="24"
                      src={ic_flag}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                  </aside>
                  <section>
                    <h5>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-4.small-heading-1"
                      )}
                    </h5>
                    <p>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-4.small-description-1"
                      )}
                    </p>
                  </section>
                </div>
                <div className="icon-left-box">
                  <aside>
                    <img
                      width="24"
                      height="24"
                      src={ic_light_bulb}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                  </aside>
                  <section>
                    <h5>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-4.small-heading-2"
                      )}
                    </h5>
                    <p>
                      {t(
                        "e-signing-api-page.e-signing-api-page-content.content-4.small-description-2"
                      )}
                      <a href="/eids" target="_blank" rel="noreferrer">
                        {t(
                          "e-signing-api-page.e-signing-api-page-content.content-4.small-description-2-1"
                        )}
                      </a>
                    </p>
                  </section>
                </div>
              </div>
              <div className="col-sm-6 m-auto">
                <img
                  src={require("../../assets/images/pictures/southeast_asia_map_4.png")}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-100">
          <div className="row api-solutions">
            <div className="col-sm-6 col-sm-offset-3 text-center">
              <img
                width="64"
                height="64"
                src={ic_key_big_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="heading font-weight-bold">
                {t(
                  "e-signing-api-page.e-signing-api-page-content.content-5.big-heading"
                )}
              </h2>
              <p className="subheading mb-50">
                {t(
                  "e-signing-api-page.e-signing-api-page-content.content-5.big-description"
                )}
              </p>
            </div>
          </div>
          <div className="row api-solutions flex">
            <div className="col-sm-6 flex pl-md-0">
              <div className="card">
                <div className="card__header">
                  <img
                    width="505"
                    height="214"
                    src={document_gateway}
                    className="img-responsive"
                    alt=""
                    decoding="async"
                    loading="lazy"
                  />
                </div>
                <div className="card__body">
                  <img
                    width="40"
                    height="40"
                    src={ic_doc_cirlce}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h3>
                    {t(
                      "e-signing-api-page.e-signing-api-page-content.content-5.small-heading-1"
                    )}
                  </h3>
                  <p>
                    {t(
                      "e-signing-api-page.e-signing-api-page-content.content-5.small-description-1"
                    )}
                  </p>
                  <div className="btns-inline">
                    <p>
                      <a href="javacript:;">
                        {t(
                          "e-signing-api-page.e-signing-api-page-content.content-5.small-link-1"
                        )}
                      </a>
                    </p>
                    <p>
                      <a href="javascript:;">
                        {t(
                          "e-signing-api-page.e-signing-api-page-content.content-5.small-link-2"
                        )}
                      </a>
                    </p>
                  </div>
                  <a
                    href="javascript:;"
                    onClick={() => setModalGatewayOpen(true)}
                    className="btn-secondary"
                  >
                    {t(
                      "e-signing-api-page.e-signing-api-page-content.content-5.button-contact-us"
                    )}
                  </a>
                </div>
              </div>
            </div>
            <div className="col-sm-6 flex pr-md-0">
              <div className="card">
                <div className="card__header">
                  <img
                    width="373"
                    height="194"
                    src={gopaperless_intergration}
                    className="img-responsive"
                    alt=""
                    decoding="async"
                    loading="lazy"
                  />
                </div>
                <div className="card__body">
                  <img
                    width="40"
                    height="40"
                    src={ic_doc_code_circle}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />{" "}
                  <h3>
                    {t(
                      "e-signing-api-page.e-signing-api-page-content.content-5.small-heading-2"
                    )}
                  </h3>
                  <p>
                    {t(
                      "e-signing-api-page.e-signing-api-page-content.content-5.small-description-2"
                    )}
                  </p>
                  <div className="btns-inline">
                    <p>
                      <a href="javacript:;">
                        {t(
                          "e-signing-api-page.e-signing-api-page-content.content-5.small-link-1"
                        )}
                      </a>
                    </p>
                    <p>
                      <a href="javacript:;">
                        {t(
                          "e-signing-api-page.e-signing-api-page-content.content-5.small-link-2"
                        )}
                      </a>
                    </p>
                  </div>
                  <a
                    href="javacript:;"
                    onClick={() => setModalApiOpen(true)}
                    className="btn-secondary"
                  >
                    {t(
                      "e-signing-api-page.e-signing-api-page-content.content-5.button-contact-us"
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container api-solutions block-more-detailed px-md-0"
          id="see-more-signing"
        >
          <div className="row flex center braker-box">
            <div className="braker-box__line">
              <hr />
            </div>
            <div className="text-center braker-box__text">
              <p>
                {t(
                  "e-signing-api-page.e-signing-api-page-content.content-6.description-1"
                )}
              </p>
              <a
                className="link-more-detailed"
                href="javascript:;"
                onClick={handleOpenTableSigning}
              >
                {t(
                  "e-signing-api-page.e-signing-api-page-content.content-6.description-2"
                )}
              </a>
            </div>
            <div className="braker-box__line">
              <hr />
            </div>
          </div>
        </div>

        {language === "en" ? (
          <div
            className="container table-more-detailed px-md-0"
            id="table-signing-open"
          >
            <div className="table-comparison mobile-hidden">
              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__header"></div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_paper_small_circle}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    With Documents Gateway:
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_paper_code_small_circle}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    With Documents API:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>UX</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Get a full user interface for document signing which
                      includes:
                    </p>
                    <p>
                      <strong>Embeddable interface.</strong> It allows to embed
                      our interface into yours as an iFrame element or modal
                      window.
                    </p>
                    <p>
                      <strong>Document viewer.</strong> It allows to view
                      documents before signing them, as well as open and view
                      already signed documents.
                    </p>
                    <p>
                      <strong>Signature information.</strong> It allows to see
                      all the information the signature and its certificate
                      contains: signing time and purpose, certificate owner,
                      issuer and validity period.
                    </p>
                    <p>
                      <strong>Batch signing.</strong> It allows you to sign
                      multiple documents with one PIN code entry.
                    </p>
                    <p>
                      <strong>Sequential signing.</strong> It allows you to add
                      a few documents to a single signing sequence. It is useful
                      in cases when the same user needs to sign a few documents
                      at once.
                    </p>
                    <p>
                      <strong>Signees management.</strong> It allows you to
                      change signees in any stage of document signing. It is
                      especially useful when someone is on vacation or doesn’t
                      work at the company anymore.
                    </p>
                    <p>
                      <strong>Localisation.</strong> It allows you to set UI to
                      GoPaperless supported languages: English, Vietnamese.
                    </p>
                    <p>
                      <strong>Customisation of UI.</strong> It allows you to
                      easily customise what Gateway looks like by applying
                      custom styles using CSS. Also interaction capabilities via
                      Javascript are available.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Get more flexibility and customisation options to
                      tailor-make an e-signing experience based on your needs by
                      only developing the necessary elements.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Document storage</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Documents in GoPaperless system are stored during the
                      signing period but not longer than 30 days. As soon as the
                      document is signed, you can download it to your own system
                      and delete it, otherwise it is deleted after 30 days
                      whether it’s been signed or not.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Documents in GoPaperless system are only processed at the
                      time of signing action, up to 300 seconds. As soon as the
                      document is signed it is returned to your system.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-comparison table-comparison--mobile">
              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_paper_small_circle}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    With Documents Gateway:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>UX</p>
                    </div>{" "}
                    <p>
                      Get a full user interface for document signing which
                      includes:
                    </p>
                    <p>
                      <strong>Embeddable interface.</strong> It allows to embed
                      our interface into yours as an iFrame element or modal
                      window.
                    </p>
                    <p>
                      <strong>Document viewer.</strong> It allows to view
                      documents before signing them, as well as open and view
                      already signed documents.
                    </p>
                    <p>
                      <strong>Signature information.</strong> It allows to see
                      all the information the signature and its certificate
                      contains: signing time and purpose, certificate owner,
                      issuer and validity period.
                    </p>
                    <p>
                      <strong>Batch signing.</strong> It allows you to sign
                      multiple documents with one PIN code entry.
                    </p>
                    <p>
                      <strong>Sequential signing.</strong> It allows you to add
                      a few documents to a single signing sequence. It is useful
                      in cases when the same user needs to sign a few documents
                      at once.
                    </p>
                    <p>
                      <strong>Signees management.</strong> It allows you to
                      change signees in any stage of document signing. It is
                      especially useful when someone is on vacation or doesn’t
                      work at the company anymore.
                    </p>
                    <p>
                      <strong>Localisation.</strong> It allows you to set UI to
                      GoPaperless supported languages: English, Vietnamese.
                    </p>
                    <p>
                      <strong>Customisation of UI.</strong> It allows you to
                      easily customise what Gateway looks like by applying
                      custom styles using CSS. Also interaction capabilities via
                      Javascript are available.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Document storage</p>
                    </div>
                    <p>
                      Documents in GoPaperless system are stored during the
                      signing period but not longer than 30 days. As soon as the
                      document is signed, you can download it to your own system
                      and delete it, otherwise it is deleted after 30 days
                      whether it’s been signed or not.
                    </p>
                  </div>
                </div>
              </div>

              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_paper_code_small_circle}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    With Documents API:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>UX</p>
                    </div>
                    <p>
                      Get more flexibility and customisation options to
                      tailor-make an e-signing experience based on your needs by
                      only developing the necessary elements.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Document storage</p>
                    </div>
                    <p>
                      Documents in GoPaperless system are only processed at the
                      time of signing action, up to 300 seconds. As soon as the
                      document is signed it is returned to your system.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="container table-more-detailed px-md-0"
            id="table-signing-open"
          >
            <div className="table-comparison mobile-hidden">
              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__header"></div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_paper_small_circle}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    Với Cổng tài liệu:
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_paper_code_small_circle}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    Với tài liệu API:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>UX</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Nhận giao diện người dùng đầy đủ để ký tài liệu bao gồm:
                    </p>
                    <p>
                      <strong>Giao diện có thể nhúng.</strong> Cho phép nhúng
                      giao diện của chúng tôi vào giao diện của bạn dưới dạng
                      phần tử iFrame hoặc cửa sổ phương thức.
                    </p>
                    <p>
                      <strong>Trình xem tài liệu.</strong> Cho phép xem các tài
                      liệu trước khi ký, cũng như mở và xem các tài liệu đã được
                      ký.
                    </p>
                    <p>
                      <strong>Thông tin chữ ký.</strong> Cho phép xem tất cả
                      thông tin mà chữ ký và chứng chỉ của nó chứa: thời gian và
                      mục đích ký, chủ sở hữu chứng chỉ, nhà phát hành và thời
                      hạn hiệu lực.
                    </p>
                    <p>
                      <strong>Ký hàng loạt.</strong> Cho phép bạn ký nhiều tài
                      liệu với một lần nhập mã PIN.
                    </p>
                    <p>
                      <strong>Ký tuần tự.</strong> Cho phép bạn thêm một số tài
                      liệu vào một trình tự ký đơn. Rất hữu ích trong trường hợp
                      cùng một người dùng cần ký một số tài liệu cùng một lúc.
                    </p>
                    <p>
                      <strong>Quản lý người đăng ký.</strong> Cho phép bạn thay
                      đổi người ký trong bất kỳ giai đoạn ký tài liệu nào. Đặc
                      biệt hữu ích khi ai đó đang đi nghỉ hoặc không làm việc ở
                      công ty nữa.
                    </p>
                    <p>
                      <strong>Nội địa hóa.</strong> Cho phép bạn thiết lập giao
                      diện người dùng sang các ngôn ngữ được GoPaperless hỗ trợ:
                      tiếng Anh, tiếng Việt.
                    </p>
                    <p>
                      <strong>Tùy chỉnh giao diện người dùng.</strong> Cho phép
                      bạn dễ dàng tùy chỉnh giao diện của Gateway bằng cách áp
                      dụng các kiểu tùy chỉnh bằng CSS. Ngoài ra khả năng tương
                      tác qua Javascript cũng có sẵn.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Nhận các tùy chọn tùy chỉnh và linh hoạt hơn để điều chỉnh
                      trải nghiệm ký điện tử dựa trên nhu cầu của bạn bằng cách
                      chỉ phát triển các yếu tố cần thiết.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Kho chứa tài liệu</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Tài liệu trong hệ thống GoPaperless được lưu trữ trong
                      thời gian ký nhưng không quá 30 ngày. Ngay sau khi tài
                      liệu được ký, bạn có thể tải xuống hệ thống của riêng mình
                      và xóa, nếu không, tài liệu sẽ bị xóa sau 30 ngày cho dù
                      đã được ký hay chưa.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Tài liệu trong hệ thống GoPaperless chỉ được xử lý tại
                      thời điểm ký hành động, tối đa 300 giây. Ngay sau khi tài
                      liệu được ký, tài liệu sẽ được trả về hệ thống của bạn.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-comparison table-comparison--mobile">
              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_paper_small_circle}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    Với Cổng tài liệu:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>UX</p>
                    </div>
                    <p>
                      Nhận giao diện người dùng đầy đủ để ký tài liệu bao gồm:
                    </p>
                    <p>
                      <strong>Giao diện có thể nhúng.</strong> Cho phép nhúng
                      giao diện của chúng tôi vào giao diện của bạn dưới dạng
                      phần tử iFrame hoặc cửa sổ phương thức.
                    </p>
                    <p>
                      <strong>Trình xem tài liệu.</strong> Cho phép xem các tài
                      liệu trước khi ký, cũng như mở và xem các tài liệu đã được
                      ký.
                    </p>
                    <p>
                      <strong>Thông tin chữ ký.</strong> Cho phép xem tất cả
                      thông tin mà chữ ký và chứng chỉ của nó chứa: thời gian và
                      mục đích ký, chủ sở hữu chứng chỉ, nhà phát hành và thời
                      hạn hiệu lực.
                    </p>
                    <p>
                      <strong>Ký hàng loạt.</strong> Cho phép bạn ký nhiều tài
                      liệu với một lần nhập mã PIN.
                    </p>
                    <p>
                      <strong>Ký tuần tự.</strong> Cho phép bạn thêm một số tài
                      liệu vào một trình tự ký đơn. Rất hữu ích trong trường hợp
                      cùng một người dùng cần ký một số tài liệu cùng một lúc.
                    </p>
                    <p>
                      <strong>Quản lý người đăng ký.</strong> Cho phép bạn thay
                      đổi người ký trong bất kỳ giai đoạn ký tài liệu nào. Đặc
                      biệt hữu ích khi ai đó đang đi nghỉ hoặc không làm việc ở
                      công ty nữa.
                    </p>
                    <p>
                      <strong>Nội địa hóa.</strong> Cho phép bạn thiết lập giao
                      diện người dùng sang các ngôn ngữ được GoPaperless hỗ trợ:
                      tiếng Anh, tiếng Việt.
                    </p>
                    <p>
                      <strong>Tùy chỉnh giao diện người dùng.</strong> Cho phép
                      bạn dễ dàng tùy chỉnh giao diện của Gateway bằng cách áp
                      dụng các kiểu tùy chỉnh bằng CSS. Ngoài ra khả năng tương
                      tác qua Javascript cũng có sẵn.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Kho chứa tài liệu</p>
                    </div>
                    <p>
                      Tài liệu trong hệ thống GoPaperless được lưu trữ trong
                      thời gian ký nhưng không quá 30 ngày. Ngay sau khi tài
                      liệu được ký, bạn có thể tải tài liệu xuống hệ thống của
                      riêng mình và xóa nó, nếu không, tài liệu sẽ bị xóa sau 30
                      ngày cho dù đã được ký hay chưa.
                    </p>
                  </div>
                </div>
              </div>

              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_paper_code_small_circle}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    Với tài liệu API:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>UX</p>
                    </div>
                    <p>
                      Nhận các tùy chọn tùy chỉnh và linh hoạt hơn để điều chỉnh
                      trải nghiệm ký điện tử dựa trên nhu cầu của bạn bằng cách
                      chỉ phát triển các yếu tố cần thiết.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Kho chứa tài liệu</p>
                    </div>
                    <p>
                      Tài liệu trong hệ thống GoPaperless chỉ được xử lý tại
                      thời điểm ký hành động, tối đa 300 giây. Ngay sau khi tài
                      liệu được ký, tài liệu sẽ được trả về hệ thống của bạn.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="api-solutions bg-color--img-overlap mt-50 bg-color">
          <div className="container identification-footer">
            <div className="row">
              <div className="col-sm-6 pl-md-0">
                <h2 className="heading font-weight-bold">
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-7.heading"
                  )}
                </h2>
                <div className="subheading">
                  <p>
                    {t(
                      "e-signing-api-page.e-signing-api-page-content.content-7.description"
                    )}
                  </p>
                </div>
                <a                 href="/uploads/BẢNG GIÁ DỊCH VỤ GOPAPERLESS.pdf"
  download="BẢNG GIÁ DỊCH VỤ GOPAPERLESS.pdf" className="btn-primary mr-16 mb-10">
                  <img
                    width="18"
                    height="18"
                    src={ic_download_white}
                    className="attachment-full size-full mt--3 mr-5"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-7.button-download-pricing"
                  )}
                </a>
                <a
                  href="javacript:;"
                  onClick={() => setModalOpen(true)}
                  className="btn-secondary"
                >
                  {t(
                    "e-signing-api-page.e-signing-api-page-content.content-7.button-contact-us"
                  )}
                </a>
              </div>
              <div className="col-sm-6 pl-md-0">
                <img
                  src={gopaperless_service}
                  width="400px"
                  className="bg-color--img-overlap__img img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      {modalOpen && (
        <Modal
          setOpenModal={setModalOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-found-solution-fit")}
          description={t("modal.description-get-started")}
          type="Solutions - E Signing API - e-Signing in your e-service"
        />
      )}
      {modalGatewayOpen && (
        <Modal
          setOpenModal={setModalGatewayOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-document-gateway")}
          description={t("modal.description-fillout-reach")}
          type="Solutions - E Signing API - Documents Gateway"
        />
      )}
      {modalApiOpen && (
        <Modal
          setOpenModal={setModalApiOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-document-api")}
          description={t("modal.description-fillout-reach")}
          type="Solutions - E Signing API - Documents API"
        />
      )}
      <ToastContainer />
    </>
  );
};

export default ESigningApiContent;
